/**
 * 账户信息
 */
<template>
    <div class="userInfo-top">
        <div>
            <span>欢迎您：{{ name }}</span>
            <span style="cursor: pointer;" @click="handleMessageDialog()">
               <!-- <el-badge :value="message" title="消息通知">
                  <i class="el-icon-message-solid"></i>
               </el-badge> -->
            </span>
            <span style="cursor: pointer;padding-left: 16px;font-size: 12px;" title="退出账户" @click="layout()">退出</span>
        </div>
      <!-- 用户修改密码 -->
      <div class="edit-password">
         <el-dialog v-dialogDrag :close-on-click-modal="false" :visible.sync="editCusPsdVisible" width="400px">
            <div style="font-size: 16px;font-weight: 700;margin-top: -20px;text-align: center;">{{ title }}</div>
            <el-form :model="passwordForm" style="margin-top: 30px;">
               <div style="margin-top: 10px;">
                  <div style="text-align: left;"><span style="color: #ff2c2c;margin-left: -6px;padding-right: 2px;">*</span>新密码</div>
                  <el-input size="small" auto-complete="off" type="password" class="invocie-input" v-model.trim="passwordForm.password" clearable></el-input>
               </div>
               <div style="margin-top: 10px;">
                  <div style="text-align: left;"><span style="color: #ff2c2c;margin-left: -6px;padding-right: 2px;">*</span>重复密码</div>
                  <el-input size="small" auto-complete="off" type="password" class="invocie-input" v-model.trim="passwordForm.passwords" clearable></el-input>
               </div>
               <div style="text-align: left;margin-top: 10px;">您的账户当前使用的是初始密码，请您修改密码。</div>
               <el-button style="width: 100%;margin-top: 20px;background-color: #2A91DD;" type="primary" @click="commitCusPassword()">确认修改</el-button>
            </el-form>
         </el-dialog>
      </div>
      <!-- 管理员修改密码 -->
      <div class="edit-password">
         <el-dialog v-dialogDrag :close-on-click-modal="false" :visible.sync="editAdminPsdVisible" width="400px">
            <div style="font-size: 16px;font-weight: 700;margin-top: -20px;text-align: center;">{{ title }}</div>
            <el-form :model="passwordForm" style="margin-top: 30px;">
               <div style="margin-top: 10px;">
                  <div style="text-align: left;"><span style="color: #ff2c2c;margin-left: -6px;padding-right: 2px;">*</span>新密码</div>
                  <el-input size="small" auto-complete="off" type="password" class="invocie-input" v-model.trim="passwordForm.password" clearable></el-input>
               </div>
               <div style="margin-top: 10px;">
                  <div style="text-align: left;"><span style="color: #ff2c2c;margin-left: -6px;padding-right: 2px;">*</span>重复密码</div>
                  <el-input size="small" auto-complete="off" type="password" class="invocie-input" v-model.trim="passwordForm.passwords" clearable></el-input>
               </div>
               <div style="text-align: left;margin-top: 10px;">您的账户当前使用的是初始密码，请您修改密码。</div>
               <el-button style="width: 100%;margin-top: 20px;background-color: #2A91DD;" type="primary" @click="commitAdminPassword()">确认修改</el-button>
            </el-form>
         </el-dialog>
      </div>
      <!-- 专家修改密码 -->
      <div class="edit-password">
         <el-dialog v-dialogDrag :close-on-click-modal="false" :visible.sync="editAgentPsdVisible" width="400px">
            <div style="font-size: 16px;font-weight: 700;margin-top: -20px;text-align: center;">{{ title }}</div>
            <el-form :model="passwordForm" style="margin-top: 30px;">
               <div style="margin-top: 10px;">
                  <div style="text-align: left;"><span style="color: #ff2c2c;margin-left: -6px;padding-right: 2px;">*</span>新密码</div>
                  <el-input size="small" auto-complete="off" type="password" class="invocie-input" v-model.trim="passwordForm.password" clearable></el-input>
               </div>
               <div style="margin-top: 10px;">
                  <div style="text-align: left;"><span style="color: #ff2c2c;margin-left: -6px;padding-right: 2px;">*</span>重复密码</div>
                  <el-input size="small" auto-complete="off" type="password" class="invocie-input" v-model.trim="passwordForm.passwords" clearable></el-input>
               </div>
               <div style="text-align: left;margin-top: 10px;">您的账户当前使用的是初始密码，请您修改密码。</div>
               <el-button style="width: 100%;margin-top: 20px;background-color: #2A91DD;" type="primary" @click="commitAgentPassword()">确认修改</el-button>
            </el-form>
         </el-dialog>
      </div>
      <!-- 消息通知弹窗 -->
      <div>
         <el-dialog v-dialogDrag :close-on-click-modal="false" :visible.sync="editMessageVisible" width="800px">
            <div style="font-size: 16px;font-weight: 700;margin-top: -20px;text-align: center;">{{ title }}</div>
            <el-table size="small" :data="messageData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;margin-top: 10px;">
               <el-table-column align="center" type="selection" width="40" fixed="left">
               </el-table-column>
               <el-table-column align="center" type="index" label="序号" width="60">
               </el-table-column>
               <el-table-column prop="title" align="center" label="标题" show-overflow-tooltip>
               </el-table-column>
               <el-table-column align="center" label="操作">
                  <template slot-scope="scope">
                     <el-button size="mini" type="primary" style="background-color: #2A91DD;">标记已读</el-button>
                     <el-button size="mini" type="primary" style="background-color: #2A91DD;">删除</el-button>
                  </template>
               </el-table-column>
            </el-table>
            <!-- 分页组件 -->
            <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
         </el-dialog>
      </div>
    </div>
</template>

<script>
import { 
    getUserInfo,
    getAdminInfo,
    getAgentInfo,
    changeUserPassword,
    changeAdminPassword,
    changeAgentPassword,
    getAdminMessageList,
    getAgentMessageList,
    getCustomerMessageList
   
} from '../api/evalMG'
import md5 from 'js-md5'
import { checkLogin } from '../utils/util'
import Pagination from './Pagination'
export default {
    name: 'topInfo',
    data() {
        return {
            name: '',
            mobile: '',
            title: '',
            message: 0,
            loading: false,
            editCusPsdVisible: false,
            editAdminPsdVisible: false,
            editAgentPsdVisible: false,
            editMessageVisible: false,
            passwordForm: {
               password: '',
               passwords: ''
            },
            messageForm: {
               page: 1,
               ps: 10
            },
            messageData: [],
            // 分页参数
            pageparm: {
               currentPage: 1,
               pageSize: 10,
               total: 10
            },
        }
    },
    // 注册组件
    components: {
         Pagination
      },
    created() {
        // 获取token和sign
        let sign = localStorage.getItem("sign")
        if(sign == 'user'){
            this.getUserInfo()
            // 查询用户消息
            // this.getCustomerMessageData()
        }
        if(sign == 'agent'){
            this.getAgentInfo()
            // 查询专家消息
            // this.getAgentMessageData()
        }
        if(sign == 'admin'){
            this.getAdminInfo()
            // 查询管理员消息
            // this.getAdminMessageData()
        }

    },
    methods: {
        // 查询普通账户信息
        getUserInfo(){
            let param = {}
            getUserInfo(param)
            .then(res=>{
                res = checkLogin(res);
                if(!res){
                 this.$message({
                   type: 'warning',
                   message: '登录已失效,请重新登录!'
                 }) 
                  // 登陆已失效 清除登陆状态
                  setTimeout(() => {
                     window.localStorage.removeItem('userToken');
                     window.localStorage.removeItem('sign');
                     window.localStorage.removeItem('userData');
                     this.$router.push({ path: '/login'});
                     }, 1000)
                }
                if(res.code == 200){
                    this.name = res.data.name
                    this.mobile = res.data.mobile
                    if(res.data.psd_flag == 1){
                        this.title = '修改密码'
                        this.passwordForm.password = ''
                        this.passwordForm.passwords = ''
                        this.editCusPsdVisible = true
                    }
                    // 将用户信息保存到本地缓存
                    localStorage.setItem('userData', JSON.stringify(res.data))
                }
            })
        },
        // 查询专家账户信息
        getAgentInfo(){
            let param = {}
            getAgentInfo(param)
            .then(res=>{
                res = checkLogin(res);
                if(!res){
                 this.$message({
                   type: 'warning',
                   message: '登录已失效,请重新登录!'
                 }) 
                  // 登陆已失效 清除登陆状态
                  setTimeout(() => {
                     window.localStorage.removeItem('userToken');
                     window.localStorage.removeItem('sign');
                     window.localStorage.removeItem('userData');
                     this.$router.push({ path: '/login'});
                     }, 1000)
                }
                if(res.code == 200){
                    this.name = res.data.name
                    this.mobile = res.data.mobile
                    if(res.data.psd_flag == 1){
                        this.title = '修改密码'
                        this.passwordForm.password = ''
                        this.passwordForm.passwords = ''
                        this.editAgentPsdVisible = true
                    }
                    // 将用户信息保存到session
                    localStorage.setItem('userData', JSON.stringify(res.data))
                }
            })
        },
        // 查询管理员账户信息
        getAdminInfo(){
            let param = {}
            getAdminInfo(param)
            .then(res=>{
                res = checkLogin(res);
                if(!res){
                 this.$message({
                   type: 'warning',
                   message: '登录已失效,请重新登录!'
                 }) 
                  // 登陆已失效 清除登陆状态
                  setTimeout(() => {
                     window.localStorage.removeItem('userToken');
                     window.localStorage.removeItem('sign');
                     window.localStorage.removeItem('userData');
                     this.$router.push({ path: '/login'});
                     }, 1000)
                }
                if(res.code == 200){
                    this.name = res.data.name
                    this.mobile = res.data.mobile
                    if(res.data.psd_flag == 1){
                        this.title = '修改密码'
                        this.passwordForm.password = ''
                        this.passwordForm.passwords = ''
                        this.editAdminPsdVisible = true
                    }
                    // 将用户信息保存到session
                    localStorage.setItem('userData', JSON.stringify(res.data))
                }
            })
        },
        // 查询管理员消息
        getAdminMessageData(){
         getAdminMessageList(this.messageForm)
         .then(res=>{
            if(res.code == 200){
               this.messageData = res.data.dataList
               this.pageparm.currentPage = this.messageForm.page
               this.pageparm.pageSize = this.messageForm.ps
               this.pageparm.total = res.data.total
            }
         })
        },
        // 查询专家消息
        getAgentMessageData(){

        },
        // 查询用户消息
        getCustomerMessageData(){
         
        },
        layout(){
            this.$confirm('确定退出吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(()=>{
                window.localStorage.removeItem('userToken');
                window.localStorage.removeItem('sign');
                window.localStorage.removeItem('userData');
                // 跳转登录首页
                this.$message({
                    type: 'success',
                    message: '已退出,即将跳转到首页'
                })
                setTimeout(()=>{
                    this.$router.push({ path: '/index/index'});
                },1000)
            }) .catch(() => {
                this.$message({
                  type: 'info',
                  message: '已取消'
                })
            })
        },
        // 用户提交密码修改
        commitCusPassword(){
            let password = this.passwordForm.password
            let passwords = this.passwordForm.passwords
            if(password.length <= 0 || passwords.length <= 0){
               this.$message({
                  type: 'warning',
                  message: '请填写必填项!'
               }) 
               return false
            }
            if(password != passwords){
               this.$message({
                  type: 'warning',
                  message: '两次输入密码不一致!'
               }) 
               return false
            }
            let param = {
               password: md5(password)
            }
            changeUserPassword(param)
            .then(res=>{
               if(res.code == 200){
                  this.$message({
                     type: 'success',
                     message: res.msg
                  })
                  this.editCusPsdVisible = false
               }else{
                  this.$message({
                     type: 'error',
                     message: res.msg
                  }) 
                  return false
               }
            })
        },
        // 管理员提交密码修改
        commitAdminPassword(){
            let password = this.passwordForm.password
            let passwords = this.passwordForm.passwords
            if(password.length <= 0 || passwords.length <= 0){
               this.$message({
                  type: 'warning',
                  message: '请填写必填项!'
               }) 
               return false
            }
            if(password != passwords){
               this.$message({
                  type: 'warning',
                  message: '两次输入密码不一致!'
               }) 
               return false
            }
            let param = {
               password: md5(password)
            }
            changeAdminPassword(param)
            .then(res=>{
               if(res.code == 200){
                  this.$message({
                     type: 'success',
                     message: res.msg
                  })
                  this.editAdminPsdVisible = false
               }else{
                  this.$message({
                     type: 'error',
                     message: res.msg
                  }) 
                  return false
               }
            })
        },
        // 专家提交密码修改
        commitAgentPassword(){
            let password = this.passwordForm.password
            let passwords = this.passwordForm.passwords
            if(password.length <= 0 || passwords.length <= 0){
               this.$message({
                  type: 'warning',
                  message: '请填写必填项!'
               }) 
               return false
            }
            if(password != passwords){
               this.$message({
                  type: 'warning',
                  message: '两次输入密码不一致!'
               }) 
               return false
            }
            let param = {
               password: md5(password)
            }
            changeAgentPassword(param)
            .then(res=>{
               if(res.code == 200){
                  this.$message({
                     type: 'success',
                     message: res.msg
                  })
                  this.editAgentPsdVisible = false
               }else{
                  this.$message({
                     type: 'error',
                     message: res.msg
                  }) 
                  return false
               }
            })
        },
        // 显示消息通知弹窗
        handleMessageDialog(){
         this.title = '消息通知'
         this.editMessageVisible = true
        },

         // 分页插件事件
         callFather(parm) {
            this.messageForm.page = parm.currentPage
            this.messageForm.ps = parm.pageSize
            // 获取token和sign
            let sign = localStorage.getItem("sign")
            if(sign == 'user'){
                  // 查询用户消息
                  this.getCustomerMessageData()
            }
            if(sign == 'agent'){
                  // 查询专家消息
                  this.getAgentMessageData()
            }
            if(sign == 'admin'){
                  // 查询管理员消息
                  this.getAdminMessageData()
            }
         },
    },

    }
</script>
<style scoped>
    .userInfo-top {
        width: 1200px;
        height: 20px;
        line-height: 20px;
        color: #FFFFFF;
        font-size: 16px;
        margin-top: 0px;
        margin-bottom: -20px;
        margin-left: auto;
        margin-right: auto;
        text-align: right;
    }
</style>


// WEBPACK FOOTER //
// src/components/topInfo.vue